<svelte:head>
<script src="https://cdn.jsdelivr.net/npm/toolcool-color-picker/dist/toolcool-color-picker.min.js"></script>
</svelte:head>
<script>
    import {onMount} from 'svelte';
    
    export let scenario;
	
	let isLoaded;
	 onMount(() => {
		isLoaded = true;
    });

    // $: localScenario = scenario;

	const changeScenarioBackColor = (e) => {
		const color = e.target.color.toRgbString();
		scenario.changeBackColor(color);
	}
</script>

<div class="background-setting">
							<div class="text-block-103">배경 색상</div> 
							<div class="toggle-button _2" on:click={scenario.toggleBackColor()}>
								<div class="toggle" class:on={scenario.isUsableBackColor()}></div>
								<div class="toggle-round" class:on={scenario.isUsableBackColor()}></div>
							</div>
							{#if scenario.isUsableBackColor()}
							<toolcool-color-picker class="color-target"
                            color={scenario.backColor} button-width="1.2rem" button-height="1.2rem"
                            button-padding="2px" on:mouseup={changeScenarioBackColor} />
							{/if}
						</div>
<style>
	.toggle {
		width: 26px;
    	height: 16px;
		background-color: gray;
	}
	.toggle.on {
		width: 26px;
    	height: 16px;
		background-color: #ff558d;
	}

	.toggle-button._2 {
		margin-top: 1px;
		margin-right: 6px;
	}

	.toggle-round {
		width: 10px;
		height: 10px;
	}

	.text-block-103 {
		width: 60px;
    	margin-right: 0px;
		font-size: 12px;
	}
	.background-setting {
		padding-left: 15px;
	}
	.color-target {
		margin-top: 6px;
	}
</style>